import * as Phaser from 'phaser';

/**
 * Faint dashed normal + symmetric arcs over a mirror, visible when
 * showAngleHelper is true on the level. Slice 1: a single dashed line
 * along the mirror normal. Arcs are a future polish enhancement.
 */
export class HelperOverlay extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, cellSize: number) {
    super(scene);
    const len = cellSize * 0.7;
    const line = scene.add.rectangle(0, -len / 2, 2, len, 0x88c8ff, 0.4).setOrigin(0.5, 0);
    this.add(line);
    scene.add.existing(this);
  }

  setMirrorAngleDeg(angleDeg: number): void {
    // Normal is perpendicular to mirror surface (mirror angle + 90°).
    this.setRotation(((angleDeg + 90) * Math.PI) / 180);
  }
}
